/**
 * Blog product carousel functionality
 * Creates responsive product sliders for blog post content areas
 * Handles product recommendations and related items within blog posts
 */

(async () => {

  if (!customElements.get('blog-product-swiper')) {

    const { default: Swiper, Navigation, Pagination, Scrollbar, Autoplay } = await import("swiper");

    Swiper.use([
      Navigation,
      Pagination,
      Scrollbar,
      Autoplay
    ]);

    class BlogProductSwiper extends HTMLElement {
      constructor() {
        super();
        this.swiperElement = this.querySelector('[data-swiper-blog-product]');
        this.swiperOptions = {
          loop: false,
          autoplay: false,
          slidesPerView: 2,
          direction: 'horizontal',
          breakpoints: {
            375: {
              slidesPerView: 1
            },
            768: {
              slidesPerView: 2
            },
            1200: {
              slidesPerView: 3
            }
          }
        }

        // Check if we have extra options on the HTML
        if (this && this.dataset && this.dataset.options) {
          const jsonOptions = JSON.parse(this.dataset.options);
          if (jsonOptions) {
            this.swiperOptions = {
              ...this.swiperOptions,
              ...jsonOptions
            };
          }
        }

        // re-init slider when Theme Editor is active
        if (Shopify.designMode && this.swiperInstance) {
          window.addEventListener('shopify:section:load', () => {
            this.swiperInstance.update();
          });
        }
        this.init();
      }

      init() {
        this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);
      }

    }

    window.BlogProductSwiper = BlogProductSwiper;

    customElements.define('blog-product-swiper', BlogProductSwiper);

  }

})();
